import { render, staticRenderFns } from "./AlarmPointDialog.vue?vue&type=template&id=9e4ddc58"
import script from "./AlarmPointDialog.vue?vue&type=script&lang=ts"
export * from "./AlarmPointDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports